<pr-form
  (onSubmit)="onSubmit()"
  title="Paramétrez votre simulation"
  [formGroup]="form"
>
  <h3>Paramètres de l'investissement</h3>

  <pr-input label="Valeur du bien" suffix="€" [derrors]="derrors">
    <input formControlName="investedAmount" type="text" />
  </pr-input>

  <pr-input-radio
    formControlName="ownership"
    label="Type d’investissement"
    [options]="[
      { value: 'FULL_OWNERSHIP', label: 'Pleine propriété' },
      { value: 'BARE_OWNERSHIP', label: 'Nue propriété' },
    ]"
  >
  </pr-input-radio>

  @if (form.get('ownership').value == 'BARE_OWNERSHIP') {
    <pr-input label="Durée de démembrement" suffix="ans" [derrors]="derrors">
      <input formControlName="dismembermentDuration" type="text" />
    </pr-input>
  }

  <pr-input label="Durée du projet" suffix="ans" [derrors]="derrors">
    <!-- (change)="onProjectDurationChange($event)" -->
    <input
      formControlName="projectDuration"
      type="text"
      (change)="onProjectDurationChange($event)"
    />
  </pr-input>
  @if (errorProjectDuration) {
    <pr-color-panel [display]="'danger'">
      <pr-panel-body clazz="pam">
        <pr-label [name]="'error'" [width]="18" [height]="18">{{
          errorProjectDuration?.message
        }}</pr-label>
      </pr-panel-body>
    </pr-color-panel>
  }

  <pr-input label="Revalorisation foncière" suffix="%" [derrors]="derrors">
    <input formControlName="partRevalorisationRate" type="text" />
  </pr-input>

  <pr-input label="Revalorisation locative" suffix="%" [derrors]="derrors">
    <input formControlName="rentalReversionRate" type="text" />
  </pr-input>

  <!-- Versement programmé + réinvestissement des dividendes : uniquement en pleine propriété.
       Le montant global est réparti au prorata sur les SCPI éligibles côté back. -->
  @if (form.get('ownership').value == 'FULL_OWNERSHIP') {
    <pr-input label="Versement programmé" suffix="€/mois" [derrors]="derrors">
      <input formControlName="globalProgrammedAmount" type="text" />
    </pr-input>

    <pr-input-radio
      formControlName="globalDividendReinvestment"
      label="Réinvestissement des dividendes"
      [options]="[
        { value: true, label: 'Oui' },
        { value: false, label: 'Non' },
      ]"
    >
    </pr-input-radio>
  }

  <!-- Credit -->
  @if (form.get('ownership').value != 'BARE_OWNERSHIP') {
    <h3>Paramètres du crédit</h3>
  }

  <pr-input-radio
    formControlName="cashOrCredit"
    label="Investissement"
    [hidden]="form.get('ownership').value == 'BARE_OWNERSHIP'"
    [options]="[
      { value: 'CASH', label: 'Cash' },
      { value: 'CREDIT', label: 'Crédit' },
    ]"
  >
  </pr-input-radio>

  <pr-input
    [hidden]="inCash"
    label="Durée du crédit"
    suffix="mois"
    [derrors]="derrors"
  >
    <!-- (change)="onProjectDurationChange($event)" -->
    <input formControlName="loanDuration" type="text" />
  </pr-input>
  @if (errorLoanDuration) {
    <pr-color-panel [display]="'danger'">
      <pr-panel-body clazz="pam">
        <pr-label [name]="'error'" [width]="18" [height]="18">{{
          errorLoanDuration?.message
        }}</pr-label>
      </pr-panel-body>
    </pr-color-panel>
  }

  <pr-input
    [hidden]="inCash"
    label="Taux du crédit"
    suffix="%"
    [derrors]="derrors"
  >
    <input formControlName="loanRate" type="text" />
  </pr-input>

  <pr-input
    [hidden]="inCash"
    label="Taux d'assurance"
    suffix="%"
    [derrors]="derrors"
  >
    <input formControlName="loanInsuranceRate" type="text" />
  </pr-input>

  <pr-input
    [hidden]="inCash"
    label="Frais bancaires"
    suffix="€"
    [derrors]="derrors"
  >
    <input formControlName="bankingFees" type="text" />
  </pr-input>
  <pr-input
    [hidden]="inCash"
    label="Franchise totale"
    suffix="mois"
    [derrors]="derrors"
  >
    <input formControlName="franchiseTotale" type="text" />
  </pr-input>
</pr-form>
